import React from "react";
import { Layout, Menu } from "antd";
import {
  GlobalOutlined,
  HomeOutlined,
  NotificationOutlined,
  SafetyCertificateOutlined,
  CarOutlined,
  MedicineBoxOutlined,
  SubnodeOutlined,
  GroupOutlined,
  ShopOutlined,
  HomeFilled,
  ThunderboltOutlined,
  SendOutlined,
  TagOutlined,
  UserOutlined,
  ExceptionOutlined,
} from "@ant-design/icons";
import { useSelector } from "react-redux";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import MedicalNetworkService from "../../api/MedicalNetwork/MedicalNetworkService";

const { SubMenu } = Menu;
const { Sider } = Layout;

export function SideBar(props) {
  const role = localStorage.getItem("role");
  return (
    <Sider className="site-layout-background" width={200}>
      <Menu
        mode="inline"
        defaultSelectedKeys={props.selectedTab}
        defaultOpenKeys={["categories"]}
        style={{ height: "100%" }}
        onClick={(value) => props.onSelectTabChange(value)}
      >
        <SubMenu
          key="categories"
          icon={
            <GlobalOutlined
              style={{ paddingBottom: "2px", verticalAlign: "middle" }}
            />
          }
          title="Categories"
        >
          <Menu.Item key="co">Create Category</Menu.Item>
          <Menu.Item key="uao">Edit Category</Menu.Item>
          <Menu.Item key="pao">All Categories</Menu.Item>
        </SubMenu>
        <SubMenu
          key="offer"
          icon={
            <HomeOutlined
              style={{ paddingBottom: "2px", verticalAlign: "middle" }}
            />
          }
          title="Offers"
        >
          <Menu.Item key="cc">Create Offer</Menu.Item>
          <Menu.Item key="uec">Edit Offer</Menu.Item>
          <Menu.Item key="ec">All Offers</Menu.Item>
        </SubMenu>
        <SubMenu
          key="life_insurance"
          icon={
            <SafetyCertificateOutlined
              style={{ paddingBottom: "2px", verticalAlign: "middle" }}
            />
          }
          title="Life Insurance"
        >
          <Menu.Item key="lcd">Create Description</Menu.Item>
          <Menu.Item key="led">Edit Description</Menu.Item>
          <Menu.Item key="lad">All Descriptions</Menu.Item>
        </SubMenu>
        <SubMenu
          key="medical_insurance"
          icon={
            <MedicineBoxOutlined
              style={{ paddingBottom: "2px", verticalAlign: "middle" }}
            />
          }
          title="Medical Insurance"
        >
          <Menu.Item key="mcc">Create Class</Menu.Item>
          <Menu.Item key="mec">Edit Class</Menu.Item>
          <Menu.Item key="mac">All Classes</Menu.Item>
        </SubMenu>
        <SubMenu
          key="car_insurance"
          icon={
            <CarOutlined
              style={{ paddingBottom: "2px", verticalAlign: "middle" }}
            />
          }
          title="Car Insurance"
        >
          <Menu.Item key="cicd">Create Description</Menu.Item>
          <Menu.Item key="cied">Edit Description</Menu.Item>
          <Menu.Item key="ciad">All Descriptions</Menu.Item>
        </SubMenu>
        <SubMenu
          key="notifications"
          icon={
            <NotificationOutlined
              style={{ paddingBottom: "2px", verticalAlign: "middle" }}
            />
          }
          title="Notifications"
        >
          <Menu.Item key="sn">Send Notification</Menu.Item>
          <Menu.Item key="en">Edit Notification</Menu.Item>
          <Menu.Item key="an">All Notifications</Menu.Item>
        </SubMenu>
        {role === "admin" && (
          <SubMenu
            key="user"
            icon={
              <UserOutlined
                style={{ paddingBottom: "2px", verticalAlign: "middle" }}
              />
            }
            title="User"
          >
            <Menu.Item key="cu">Create User</Menu.Item>
            <Menu.Item key="eu">Edit User</Menu.Item>
            <Menu.Item key="pau">All Users</Menu.Item>
          </SubMenu>
        )}
        <SubMenu
          key="feedback"
          icon={
            <ExceptionOutlined
              style={{ paddingBottom: "2px", verticalAlign: "middle" }}
            />
          }
          title="Feedback"
        >
          <Menu.Item key="mailconfig">Mail Configuration</Menu.Item>
          <Menu.Item key="sf">Create Feedback</Menu.Item>
          <Menu.Item key="pf">All Feedbacks</Menu.Item>
        </SubMenu>
        <Menu.Item
          icon={
            <SendOutlined
              style={{ paddingBottom: "2px", verticalAlign: "middle" }}
            />
          }
          key="executeMigration"
          onClick={() =>
            MedicalNetworkService.executeMigration().then(() =>
              toast
                .success(`Medical Network Migrated Successfully`, {
                  position: toast.POSITION.TOP_CENTER,
                })
                .catch((err) =>
                  toast.error(`Error in Migrating Medical Network`, {
                    position: toast.POSITION.TOP_CENTER,
                  })
                )
            )
          }
        >
          Execute Migration
        </Menu.Item>
      </Menu>
    </Sider>
  );
}
